export enum CardDocumentAction {
	ARCHIVE = 'ARCHIVE',
	DELETE = 'DELETE',
	DOWNLOAD = 'DOWNLOAD',
	MOVE = 'MOVE',
	CHANGE = 'CHANGE'
}
